import { API_BASE_URL } from '../config';
import { AuthPayload } from '../types';

export interface LoginParams {
  username: string;
  password: string;
}

export interface RegisterParams {
  name: string;
  username: string;
  email: string;
  password: string;
  roles: string[];
}

export async function login(params: LoginParams): Promise<AuthPayload> {
  const response = await fetch(`${API_BASE_URL}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params)
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Credenciais inválidas');
  }

  const payload = (await response.json()).data as AuthPayload;
  return payload;
}

export async function refreshToken(refreshToken: string): Promise<AuthPayload> {
  const response = await fetch(`${API_BASE_URL}/auth/refresh`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refreshToken })
  });

  if (!response.ok) {
    throw new Error('Failed to refresh token');
  }

  const payload = (await response.json()).data as AuthPayload;
  return payload;
}

export async function logout(params: { accessToken?: string; refreshToken: string }): Promise<void> {
  await fetch(`${API_BASE_URL}/auth/logout`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(params.accessToken ? { Authorization: `Bearer ${params.accessToken}` } : {})
    },
    body: JSON.stringify({ refreshToken: params.refreshToken })
  });
}

export async function register(params: RegisterParams, accessToken: string): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/auth/register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    body: JSON.stringify(params)
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Não foi possível registrar o usuário');
  }
}
